const DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000

const parseDateOnly = (date) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date || '')) return null

  const [year, month, day] = date.split('-').map(Number)
  const parsedDate = new Date(Date.UTC(year, month - 1, day))

  if (
    parsedDate.getUTCFullYear() !== year ||
    parsedDate.getUTCMonth() !== month - 1 ||
    parsedDate.getUTCDate() !== day
  ) {
    return null
  }

  return parsedDate
}

export const getDocumentExpirationStatus = (
  expirationDate,
  today = new Date()
) => {
  const parsedExpirationDate = parseDateOnly(expirationDate)
  if (!parsedExpirationDate) return null

  const currentDate = Date.UTC(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  )
  const daysUntilExpiration =
    (parsedExpirationDate.getTime() - currentDate) / DAY_IN_MILLISECONDS

  if (daysUntilExpiration < 0) return 'expired'
  if (daysUntilExpiration <= 30) return 'expiringSoon'

  return null
}

export const getDocumentExpirationSummary = (documents, today = new Date()) => {
  const summary = documents.reduce(
    (counts, document) => {
      const status = getDocumentExpirationStatus(
        document.expirationDate,
        today
      )

      if (status === 'expired') counts.expiredCount += 1
      if (status === 'expiringSoon') counts.expiringSoonCount += 1

      return counts
    },
    { expiredCount: 0, expiringSoonCount: 0 }
  )

  return {
    ...summary,
    severity: summary.expiredCount > 0 ? 'error' : 'warning',
  }
}
